import React from 'react';

import SettingsIcon from '@atlaskit/icon/glyph/settings';
import { openEditRuleDialog, openRemoveRuleDialog } from 'src/services/rules';

import MenuDropdown from 'src/views/components/MenuDropdown';

const MoreActions = ({ id }) => {
  return (
    <div className="more-actions">
      <MenuDropdown
        triggerType="button"
        triggerButtonProps={{
          iconBefore: <SettingsIcon size="medium" />
        }}
        items={[{
          name: 'Edit',
          key: 'edit',
          action: () => openEditRuleDialog(id)
        },
        {
          name: 'Remove',
          key: 'remove',
          action: () => openRemoveRuleDialog(id)
        }]}
      />
    </div>
  );
};

export default MoreActions;
